const useColors = () => {
  const documentCSS = getComputedStyle(document.documentElement);
  return {
    colorPrimary:
      documentCSS.getPropertyValue('--llui-color-primary').trim() || '#f9cf36',
    colorOnPrimary:
      documentCSS.getPropertyValue('--llui-color-on-primary').trim() ||
      '#ffffff',
    colorSecondary:
      documentCSS.getPropertyValue('--llui-color-secondary').trim() ||
      '#d3edf1',
    colorOnSecondary:
      documentCSS.getPropertyValue('--llui-color-on-secondary').trim() ||
      '#ffffff',
  };
};

export default useColors;
